import api from "../helpers/interceptor";

// ---------Jobs list ---------
export const JobsListing = async (payload) =>
  await api.get(
    `/jobs/getJobsList?page=${payload.page}&limit=${payload.limit}&search_key=${payload.search_key}`
  );

//-------status-----------//
export const JobsStatus = async (payload) =>
  await api.put(`/jobs/updateJobStatus`, payload);

// view detail api
export const ViewJobDetail = async (job_id) => {
  return await api.get(`/jobs/getJobDetails?job_id=${job_id}`);
};

// --------- InternShip listing-----------------
export const InternListing = async (payload) =>
  await api.get(
    `/internships/getInternshipsList?page=${payload.page}&limit=${payload.limit}&search_key=${payload.search_key}`
  );

// ---------------InternShip staus--------------
export const InternStatus = async (payload) =>
  await api.put(`/internships/updateInternshipStatus`, payload);

// -------------------View Internship---------------
export const ViewInternDetail = async (intern_id) => {
  return await api.get(
    `/internships/getInternshipDetails?internship_id=${intern_id}`
  );
};
